// extracted by mini-css-extract-plugin
export default {"button":"BSw7Jl5qMH_pdp","extraClickZone":"vrfk8p2oSc_pdp"};